import { Injectable } from '@angular/core';
import { AppConfiguration } from '@shared/models/app-configuration';

import configuration from '@assets/app-configuration.json';

@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {
  public hotlineNumber: string;

  constructor() {
    this.hotlineNumber = configuration.hotlineNumber;
  }

}
